import React from 'react';

const Spinner = () => (
  <div className="animate-spin h-5 w-5 border-4 border-blue-500 rounded-full border-t-transparent"></div>
);

export default Spinner;
